import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Tooltip } from 'primereact/tooltip';
import { ReactComponent as IconGreyInfo } from '../../../../../assets/dashboard/grey-info-icon.svg';
import { formatValueWithoutCurrency } from '../../../../../helpers/currency.helper';
import Heading from '../../../../../generic-components/Heading';
import { useStore } from '../../../../../store';

export const TaxSavings = () => {
  const [, setShowTooltip] = useState<boolean>(false);
  const { t } = useTranslation();
  const taxSavingAmount = useStore((state) => state.taxSavingAmount);
  const handleShowTooltip = (event: React.MouseEvent<HTMLElement>) => {
    event.stopPropagation();
    setShowTooltip((show) => !show);
  };

  return (
    <div className='flex items-center relative'>
      <div
        className='flex font-metricRMedium text-bw08 text-[20px] leading-6 mr-[7px]'
        data-testid='TaxSavings__amount'
      >
        <span className='text-sm relative top-[-3px]'>$</span>
        {formatValueWithoutCurrency(taxSavingAmount, 0)}
      </div>
      <div className='font-metricR text-action05 text-sm leading-4 mr-[7px]'>{t('YEARS_TAX_SAVINGS.TITLE')}</div>
      <div className='relative'>
        <div
          onClick={handleShowTooltip}
          role='button'
          onKeyDown={() => {}}
          tabIndex={0}
          data-testid='TaxSavings__tooltip-icon'
        />
        <div className='savings-tooltip'>
          <IconGreyInfo className='w-[20px] h-[20px]' />
        </div>
        <Tooltip
          unstyled
          target='.savings-tooltip'
          className=' absolute max-h-[100px] max-w-[254px] my-[-18px]'
          position='top'
        >
          <div className='rounded-md py-[12px] px-[16px] bg-bw00 border border-bw03'>
            <Heading
              title={t('YEARS_TAX_SAVINGS.TOOLTIP_TITLE')}
              className='font-metricRSemibold text-sm text-bw07 '
              testId='TaxSavings__tooltip-title'
            />
            <p className='font-metricR text-sm text-bw07 z-100  mr-3' data-testid='TaxSavings__tooltip-content'>
              {t('YEARS_TAX_SAVINGS.TOOLTIP_CONTENT')}
            </p>
          </div>
        </Tooltip>
      </div>
    </div>
  );
};
